export function arrayReplaceWhere<T>(array: T[], newValue: T, condition: (valueInArray: T) => boolean) {
  const index = array.findIndex(condition);
  
  // We avoid modifying the revious array
  const replacementArray = [...array];
  replacementArray[index] = newValue;

  return replacementArray;
}